import * as React from 'react';

import { FarIcon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

function Breadcrumb({ className, ...props }: React.ComponentProps<'nav'>) {
	// Theme
	const rootClassName = cn('min-w-0 overflow-x-auto', className);

	// Render
	return <nav aria-label='Breadcrumb' className={rootClassName} {...props} />;
}

function BreadcrumbList({ className, ...props }: React.ComponentProps<'ol'>) {
	// Theme
	const rootClassName = cn(
		'flex items-center gap-1.5 text-xs leading-4 font-medium whitespace-nowrap text-foreground-body',
		className,
	);

	// Render
	return <ol className={rootClassName} {...props} />;
}

function BreadcrumbItem({ className, ...props }: React.ComponentProps<'li'>) {
	// Theme
	const rootClassName = cn('flex items-center gap-1.5', className);

	// Render
	return <li className={rootClassName} {...props} />;
}

function BreadcrumbLink({ className, ...props }: React.ComponentProps<typeof Link>) {
	// Theme
	const rootClassName = cn(
		'h-auto w-auto p-0 text-xs leading-4 font-medium text-foreground-body no-underline hover:text-foreground aria-[current=page]:text-foreground',
		className,
	);

	// Render
	return <Link variant='link' size='xs' className={rootClassName} {...props} />;
}

function BreadcrumbPage({ className, ...props }: React.ComponentProps<'span'>) {
	// Theme
	const rootClassName = cn('text-xs leading-4 font-medium text-foreground', className);

	// Render
	return <span aria-current='page' className={rootClassName} {...props} />;
}

function BreadcrumbSeparator({ className, ...props }: React.ComponentProps<'span'>) {
	// Theme
	const rootClassName = cn('flex text-foreground-body/60', className);

	// Render
	return (
		<span aria-hidden className={rootClassName} {...props}>
			<FarIcon icon='chevron-right' className='size-3' />
		</span>
	);
}

export { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator };
